// extracted by mini-css-extract-plugin
export default {"actions":"FormModal_actions__pMloi"};